import { SwapOutlined } from "@ant-design/icons";

function PredecessorSuccessorTag(props: { title: string; showIcon?: boolean }) {
  const { title, showIcon = true } = props;
  return (
    <div className="flex text-xs bg-ciq-gray-100 text-black text-opacity-90 italic rounded-[4px] p-1 px-2 space-x-1 items-center">
      {showIcon && <SwapOutlined className="text-ciq-gray-700" />}
      <span>{title}</span>
    </div>
  );
}
export default PredecessorSuccessorTag;
